import { pickBy } from 'lodash';

const isNotUndefined = (value: any) => {
  return value !== undefined && value !== null;
};

const removeUndefinedFilters = (filters: Record<string, any>) => {
  return pickBy(filters, isNotUndefined);
};

export default removeUndefinedFilters;
